module.exports = [{
        'city': "Praha",
        'address': [
            {
                'street': "V Pískovně 305",
                'city': "Praha 5 - Zličín",
                'tel': "257 951 880",
                'hours': " Pondělí až neděle 9:00 - 19:00 hod",
                'IDDeliveryMethod' : 12,
                'url' : 'https://www.google.cz/maps/place/V+P%C3%ADskovn%C4%9B+305,+155+21+Praha-Praha-Zli%C4%8D%C3%ADn/@50.0611249,14.291525,17z/data=!3m1!4b1!4m2!3m1!1s0x470bbe6becf8cff9:0xfa2c273764956ddc?hl=cs',

            }, 
            {
                'street': "Vašátkova 1",
                'city': "Praha 9 - Černý Most",
                'tel': "281 914 904",
                'hours': " Pondělí až neděle 9:00 - 19:00 hod",
                'IDDeliveryMethod' : 16,
                'url' : 'https://www.google.cz/maps/place/Va%C5%A1%C3%A1tkova+1,+198+00+Praha+14/@50.1018839,14.5648594,17z/data=!3m1!4b1!4m2!3m1!1s0x470bed4fac614f8b:0xdf40cbf83c56c38d?hl=cs'
            }
        ]
    }, 
    {
        'city': "Brno",
        'address': [
            {
                'street': "Evropská 675",
                'city': "Brno - Modřice",
                'tel': "545 213 219",
                'hours': " Pondělí až neděle 9:00 - 19:00 hod",
                'IDDeliveryMethod' : 13,
                'url' : 'https://www.google.cz/maps/place/Evropsk%C3%A1+675,+664+42+Mod%C5%99ice/@49.1073275,16.6012201,17z/data=!3m1!4b1!4m2!3m1!1s0x4712bf9c684a972d:0xcd9f286fab5b8984?hl=cs'
            }, {
                'street': "Cejl 9",
                'city': "Brno - Zábrdovice",
                'tel': "545 213 219",
                'hours': " Pondělí až pátek 9:00 - 19:00 <br> Sobota 9:00 - 12:00",
                'IDDeliveryMethod' : 14,
                'url' : 'https://www.google.cz/maps/place/Cejl+477%2F9,+Z%C3%A1brdovice,+602+00+Brno-Brno-st%C5%99ed/@49.1975121,16.6142373,17z/data=!3m1!4b1!4m2!3m1!1s0x47129458603624d1:0x3cad50ea4e602ed6?hl=cs'
            }
        ]
    }, 
    {
        'city': "Zlín",
        'address': [{
                'street': "areál Svit, budova č. 51",
                'city': "Zlín",
                'tel': "577 219 186",
                'hours': " Pondělí až neděle 9:00 - 19:00 hod",
                'IDDeliveryMethod' : 17,
                'url' : 'https://www.google.cz/maps/place/IDEA+n%C3%A1bytek,+s.r.o./@49.2221779,17.6521088,17z/data=!3m1!4b1!4m2!3m1!1s0x4713734d79b914e5:0x3ba9c2356ee7e101?hl=cs'
        }]
    },
    {
        'city': "Ostrava",
        'address': [{
                'street': "Vítkovická 2b",
                'city': "Ostrava",
                'tel': "596 635 635",
                'hours': " Pondělí až neděle 9:00 - 19:00 hod",
                'IDDeliveryMethod' : 15,
                'url' : 'https://www.google.cz/maps/place/V%C3%ADtkovick%C3%A1+3326%2F2B,+Moravsk%C3%A1+Ostrava,+702+00+Ostrava-Moravsk%C3%A1+Ostrava+a+P%C5%99%C3%ADvoz/@49.8295199,18.2753537,17z/data=!3m1!4b1!4m2!3m1!1s0x4713e338a4635fe5:0x5a7cc434bcbbd4cf?hl=cs'
        }]
    },
    {
        'city': "Pardubice",
        'address': [{
                'street': "Čeperka 306 (OC Vesna)",
                'city': "Pardubice",
                'tel': "466 263 263",
                'hours': " Pondělí až neděle 9:00 - 18:00 hod",
                'IDDeliveryMethod' : 18,
                'url' : 'https://www.google.cz/maps/place/%C4%8Ceperka,+538+51+Chrast/@49.9025218,15.9308571,17z/data=!3m1!4b1!4m2!3m1!1s0x470db872fd43cecb:0xea547f60a9b06024?hl=cs'
        }]
    },
    {
        'city': "Teplice",
        'address': [{
                'street': "Masarykova tř. 1806",
                'city': "Teplice",
                'tel': "417 820 820",
                'hours': " Pondělí až neděle 9:00 - 19:00 hod",
                'IDDeliveryMethod' : 19,
                'url' : 'https://www.google.cz/maps/place/Masarykova+t%C5%99.+1806,+Trnovany,+415+01+Teplice/@50.6516283,13.838641,17z/data=!3m1!4b1!4m2!3m1!1s0x47098e5ef2d401d5:0xbc23651f32c1540f?hl=cs'
        }]
    },
    {
        'city': "Plzeň",
        'address': [{
                'street': "Doubravka, Školní 52",
                'city': "Plzeň",
                'tel': "377 423 423",
                'hours': " Pondělí až neděle 9:00 - 19:00 hod",
                'IDDeliveryMethod' : 20,
                'url' : 'https://www.google.cz/maps/place/%C5%A0koln%C3%AD+1302%2F52,+Doubravka,+312+00+Plze%C5%88-Plze%C5%88+4/@49.7537933,13.4221487,17z/data=!3m1!4b1!4m2!3m1!1s0x470af04aa3cdad8f:0x9068b154e9164e73?hl=cs'
        }]
    },
    {
        'city': "Znojmo",
        'address': [{
                'street': "Vídeňská třída 83",
                'city': "Znojmo",
                'tel': "515 234 234",
                'hours': " Pondělí až neděle 9:00 - 19:00 hod",
                'IDDeliveryMethod' : 21,
                'url' : 'https://www.google.cz/maps/place/V%C3%ADde%C5%88sk%C3%A1+t%C5%99.+2920%2F83,+669+02+Znojmo/@48.8435214,16.0594747,17z/data=!3m1!4b1!4m2!3m1!1s0x476d5453da81a761:0x45621f0b6b818d81?hl=cs'
        }]
    },
    {
        'city': "Olomouc",
        'address': [{
                'street': "Nákupní park HANÁ, Kafkova 43",
                'city': "Olomouc",
                'tel': "585 012 012",
                'hours': " Pondělí až neděle 9:00 - 19:00 hod",
                'IDDeliveryMethod' : 22,
                'url' : 'https://www.google.cz/maps/place/Kafkova+465%2F43,+Slavon%C3%ADn,+783+01+Olomouc/@49.5746962,17.2244918,17z/data=!3m1!4b1!4m2!3m1!1s0x47124e47e73e891b:0xaa1a88365b7181d3?hl=cs'
        }]
    },
    {
        'city': "Liberec",
        'address': [{
                'street': "Františkov, Švermova 24",
                'city': "Liberec 10",
                'tel': "482 770 211",
                'hours': " Pondělí až pátek 9:00 - 19:00 <br> Sobota 9:00 - 12:00",
                'IDDeliveryMethod' : 23,
                'url' : 'https://www.google.cz/maps/place/%C5%A0vermova+352%2F24,+Franti%C5%A1kov,+460+10+Liberec/@50.763617,15.0357436,17z/data=!3m1!4b1!4m2!3m1!1s0x47093692289afb41:0x8fdbcee5134dd37a?hl=cs'
        }]
    }
]